<template>
    <div>
        <footer class="footer" v-if="globals.publicConfig && globals.publicConfig.website && globals.publicConfig.website.showFooter">
            <div class="footer-container">
                <div class="footer-top">
                    <div class="footer-column">
                        <h6>{{$t('HELP')}}</h6>
                        <ul>
                            <li><a href="#">{{$t('FOOTERRULES')}}</a></li>
                            <li><a href="#">{{$t('FOOTERHELP')}}</a></li>
                            <li><a href="#">{{$t('FOOTERRESPONSIBILITY')}}</a></li>
                            <li><a href="#">{{$t('FOOTERPRIVACY')}}</a></li>
                            <li><a href="#">{{$t('FOOTERCONDITIONS')}}</a></li>
                        </ul>
                    </div>
                    <div class="footer-column">
                        <h6>{{$t('BETTING')}}</h6>
                        <ul>
                            <li><a href="#">{{$t('FOOTERDAILYOFFER')}}</a></li>
                            <li><a href="#">{{$t('FOOTERWEEKLYOFFER')}}</a></li>
                            <li><a href="#">{{$t('FOOTERRESULTS')}}</a></li>
                            <li><a href="#">{{$t('FOOTERSPORT')}}</a></li>
                            <li><a href="#">{{$t('FOOTERLIVE')}}</a></li>
                        </ul>
                    </div>
                    <div class="footer-column">
                        <h6>{{$t('PAYMENTMETHODS')}}</h6>
                        <div class="payment-methods">
                            <div class="payment-row">
                                <img src="../../assets/img/kartica-visa.png">
                                <img src="../../assets/img/kartica-master.png">
                                <img src="../../assets/img/kartica-maestro.png">
                            </div>
                            <div class="payment-row">
                                <img src="../../assets/img/kartica-revolut.png">
                                <img src="../../assets/img/kartica-skrill.png">
                                <img src="../../assets/img/kartica-aircash.png">
                            </div>
                        </div>
                    </div>
                    <div class="footer-column">
                        <h6>{{$t('RESPONSIBLEBETTING')}}</h6>
                        <div class="responsible-betting">
                            <img src="../../assets/img/responsible-betting.svg">
                            <p v-html="$t('RESPONSIBLEBETTINGTEXT')"></p>
                        </div>
                    </div>
                </div>
                <div class="footer-bottom">
                    <div class="footer-text">
                        <p>{{$t('FOOTERCOMPANYDISCLAIMER')}}</p>
                        <p v-html="$t('FOOTERCOMPANYDISCLAIMERTEXT')"></p>
                    </div>
                </div>
            </div>
        </footer>
        <footer v-if="footerHtml" v-html="footerHtml"></footer>
    </div>
</template>
<script>

import { mapGetters } from 'vuex';
import WikiApi from '../api/Wiki';

export default {
    name: 'Footer',
    data()
    {
        return {
            footerHtml: null,
        };
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
    },
    created()
    {
        const me = this;

        me.fetchFooter();
    },
    methods:
    {
        async fetchFooter()
        {
            const me = this;
            try
            {
                const data = await WikiApi.getWikiByName('footer');
                if (data.error === false && data.header)
                {
                    me.footerHtml = data.data;
                }
            }
            catch (error)
            {
                console.log(error);
            }
        },
    },
};
</script>
